const images = require.context('../assets/imgs/', true);

const imgs = {};

images.keys().forEach((image) => {
	imgs[image.substr(2, image.lastIndexOf('.') - 2)] = images(image);
});

export default imgs;
